import {Label} from "flowbite-react";

export type FieldType = "text" | "date" | "number" | "phone" | "array";

interface NeoSubHeaderProps {
  label: string;
  value: string | string[];
  type?: FieldType;
  isExpired?: boolean;
}

export const NeoLabel: React.FC<NeoSubHeaderProps> = ({
  label,
  value,
  type,
  isExpired
}) => {
  const valueClassName = isExpired
    ? "mb-2 block font-semibold text-red-600"
    : "mb-2 block font-semibold";

  if (type === "phone") {
    return (
      <>
        <Label className="mb-2 block text-gray-500" value={label} />
        <Label
          className="mb-2 block font-semibold text-black"
          value={value as string}
        />
      </>
    );
  }

  return (
    <>
      <Label className="mb-2 block text-gray-500" value={label} />
      <Label className={valueClassName} value={value as string} />
    </>
  );
};
